<template>
  <div class="chapterlist fl">
    <div class="newroll" @click="isOpenVo">+新建卷</div>
    <!-- 章节列表 -->
    <div class="bscroll" ref="slider1" v-show="!isShowList">
      <div class="content">
        <el-collapse accordion v-model="volumeindex" @change="chooseVo">
          <el-collapse-item
            v-for="volumn in volumnList"
            :key="volumn.id"
            :voId="volumn.id"
            :title="volumn.iname"
            :name="volumn.id"
          >
            <div
              v-for="chapter in volumn.chapters"
              :key="chapter.id"
              :chId="chapter.id"
              :class="{ mychapter: true, active: chapter.id == newChapter }"
              @click="chooseChapter(chapter.id, chapter.inspectStatus)"
            >
              <p class="chapterName ellipsis clearfix">
                <span class="ellipsis name fl">{{ chapter.iname }}</span>
                <span class="info-two fr">{{ chapter.inspectStatus }}</span>
              </p>
              <p class="chapter-info clearfix">
                <span class="info-one fl">{{ chapter.words }}字</span>

                <template>
                  <span
                    class="fr"
                    style="max-height:24px;overflow:hidden;line-height:24px"
                  >
                    {{ chapter.publishTime }}</span
                  >
                </template>
              </p>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="bscroll" ref="slider" v-show="isShowList">
      <div class="content">
        <div
          v-for="chapter in chapterList"
          :key="chapter.id"
          :chId="chapter.id"
          :class="{ mychapter: true, active: chapter.id == newChapter }"
          @click="chooseChapter(chapter.id)"
        >
          <p class="chapterName ellipsis clearfix">
            <span class="ellipsis name fl">{{ chapter.iname }}</span>
            <span class="info-two fr">{{ chapter.inspectStatus }}</span>
          </p>
          <p class="chapter-info clearfix">
            <span class="info-one fl">{{ chapter.words }}字</span>
            <span class="fl" style="margin:0 2px"> | </span>
            <template>
              <span
                class="fl"
                style="max-height:24px;overflow:hidden;line-height:24px"
              >
                {{ chapter.updateTime }}</span
              >
            </template>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* 引入better-scroll */
import BScroll from "better-scroll";
export default {
  props: {
    chapterList: Array,
    isShowList: Boolean,
    volumnList: Array,
    newChapter: String,
    volumechooseId: String
  },
  data() {
    return {
      volumeindex: this.volumechooseId
    };
  },
  watch: {
    volumechooseId: {
      handler(newName) {
        this.volumeindex = newName;
      }
    }
  },

  created() {
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs["slider"], {
        scrollbar: true,
        click: true
      });
      this.scroll1 = new BScroll(this.$refs["slider1"], {
        scrollbar: true,
        click: true
      });
    });
  },
  methods: {
    isOpenVo() {
      this.$emit("isOpenVo", true);
    },
    // 选择章节
    chooseChapter(id) {
      this.$emit("chapterId", id);
    },
    chooseVo(vo) {
      this.$emit("volumeshow", vo);
    }
  },
  mounted() {}
};
</script>
<style>
.bscroll .el-collapse-item__header {
  height: 32px;
  line-height: 32px;
  background: rgba(239, 239, 239, 1);
  padding-left: 14px;
  color: #6c6c6c;
}
.bscroll .el-collapse-item__wrap {
  border: none;
}
.bscroll .el-collapse-item__content {
  padding-bottom: 0px;
}
</style>

<style lang="stylus" scoped>
.chapterlist
    width 200px
    height 100%
    .chapterName
        .name
            height 24px
            width 110px
    .newroll
        width 68px
        height 24px
        background #48a2df
        border-radius 4px
        color #fff
        font-size 12px
        line-height 24px
        text-align center
        margin 24px auto
        cursor pointer
    .bscroll
        height 700px
        width 200px
        overflow hidden
        position relative
        .mychapter
            padding 8px 14px 8px 14px
            color #333333
            font-size 14px
            line-height 24px
            border-bottom 1px solid rgba(239, 239, 239, 1)
            box-sizing border-box
            .info-two
                color #2993DB
                font-size 12px
            &.active
                background rgba(237, 248, 252, 1)
            .chapter-info
                font-size 12px
                color #888888
</style>
